module.exports = __webpack_public_path__ + "static/img/icon_user_gold.7d97c019.png";